require('../../template/timepicker/timepicker.html.js');
require('./timepicker');

var MODULE_NAME = 'ui.bootstrap.module.timepicker';

angular.module(MODULE_NAME, ['ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/timePicker/index-nocss.js
// module id = 1521
// module chunks = 1